import { MinLengthError } from '../../validation/errors/min-length-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'

export class MinLengthValidation implements FieldValidation {
  readonly field: string
  private readonly minLength: number

  constructor (field: string, minLength: number) {
    this.field = field
    this.minLength = minLength
  }

  validate (value: string): Error | null {
    if (value.length < this.minLength) return new MinLengthError(this.minLength)
    return null
  }
}
